export const Logo = (props) => (
  <svg className="nf-logo" viewBox="0 0 441.08 89.26" {...props}>
    <g>
      <circle className="cls-1" cx="44.63" cy="44.63" r="44.63" />
      <path
        className="cls-2"
        d="M87.67,32.89a44.32,44.32,0,0,0-20-26.42L64.15,14a36.31,36.31,0,0,1-10,65.66A36.67,36.67,0,0,1,44.56,81,36.33,36.33,0,0,1,35.07,9.59a36.69,36.69,0,0,1,9.63-1.3,36.16,36.16,0,0,1,16.39,4l4.69-6.89A44.26,44.26,0,0,0,44.7,0,44.67,44.67,0,0,0,1.59,56.36a44.66,44.66,0,0,0,43,32.9A44.68,44.68,0,0,0,87.67,32.89Z"
      />
      <path
        className="cls-2"
        d="M35.76,12.09a33.73,33.73,0,0,0-7.87,61.82h0l3.29-5.74-.73-.42,8.09-18.41L18.69,52.57,18.25,51,37,43.66,20.67,31.9l.83-1.45,18.41,8.09L36.69,18.69l1.61-.44,6.82,17.51L59.63,14.43a33.49,33.49,0,0,0-23.87-2.34Z"
      />
      <path
        className="cls-2"
        d="M128.46,5.45h7.46V40.24h-7.16L111.91,17.87V40.24H104.4V5.45h7.16l16.9,22.46Z"
      />
      <path
        className="cls-2"
        d="M171.25,7.24a17.41,17.41,0,0,1,9.2,15.56,17.6,17.6,0,0,1-9.2,15.63,20.26,20.26,0,0,1-19,0A17.74,17.74,0,0,1,145.53,32a17.52,17.52,0,0,1-2.46-9.17,17.46,17.46,0,0,1,9.17-15.56,20.47,20.47,0,0,1,19,0Zm-14.76,6a10.78,10.78,0,0,0-3.93,4,11.06,11.06,0,0,0-1.44,5.57,11,11,0,0,0,1.47,5.61,11.25,11.25,0,0,0,3.93,4,10.15,10.15,0,0,0,5.34,1.49,10,10,0,0,0,5.29-1.47,10.65,10.65,0,0,0,3.83-4,11.52,11.52,0,0,0,1.42-5.64A11.26,11.26,0,0,0,171,17.23a10.74,10.74,0,0,0-3.83-4,10,10,0,0,0-5.29-1.47A10.38,10.38,0,0,0,156.49,13.23Z"
      />
      <path
        className="cls-2"
        d="M208,40.24l-5.51-9.94h-8v9.94h-7.85V5.45h15.11q6.81,0,10.54,3.16T216,17.53a13.43,13.43,0,0,1-1.67,6.88,10.66,10.66,0,0,1-4.85,4.35l7.41,11.48Zm-13.52-16.5h7.26a7.54,7.54,0,0,0,5.05-1.52,5.55,5.55,0,0,0,1.76-4.44,5.33,5.33,0,0,0-1.76-4.35A7.7,7.7,0,0,0,201.72,12h-7.26Z"
      />
      <path
        className="cls-2"
        d="M220.16,5.45h29.08v6.66H238.6V40.24h-7.85V12.11H220.16Z"
      />
      <path
        className="cls-2"
        d="M256.44,5.45h7.86V20h15.75V5.45h7.85V40.24h-7.85V26.52H264.3V40.24h-7.86Z"
      />
      <path className="cls-2" d="M297.55,5.45h7.85V33.38h14.91v6.86H297.55Z" />
      <path
        className="cls-2"
        d="M354.85,40.24l-2.73-6.76H336l-2.73,6.76h-8.1L340.29,5.45h8.1l14.86,34.79ZM338.6,27.17h11l-5.47-13.52Z"
      />
      <path
        className="cls-2"
        d="M391.93,5.45h7.45V40.24h-7.15L375.38,17.87V40.24h-7.51V5.45H375l16.9,22.46Z"
      />
      <path
        className="cls-2"
        d="M432.29,7.66a16.1,16.1,0,0,1,6.48,6.16,17.59,17.59,0,0,1,2.31,9,17.22,17.22,0,0,1-2.36,9A16.3,16.3,0,0,1,432.14,38a20.55,20.55,0,0,1-9.65,2.21H408V5.45h14.76A20.05,20.05,0,0,1,432.29,7.66Zm-4.1,24.6a9.48,9.48,0,0,0,3.6-3.8,11.71,11.71,0,0,0,1.29-5.57,11.37,11.37,0,0,0-1.37-5.61A9.78,9.78,0,0,0,428,13.43a10.52,10.52,0,0,0-5.35-1.37h-6.76V33.63H423A10,10,0,0,0,428.19,32.26Z"
      />
      <path
        className="cls-3"
        d="M70.57,36.69,71,38.3,52.27,45.6,68.58,57.35l-.83,1.46L49.34,50.72l3.23,19.85L51,71,43.66,52.27,31.9,68.58l-.72-.41-3.29,5.74A33.73,33.73,0,0,0,63,16.37L52,39.7Z"
      />
      <path
        className="cls-3"
        d="M104.62,51.42H127.3l0,5.5H110.91v8.87H125.8v5.49H110.91v13h-6.29Z"
      />
      <path
        className="cls-3"
        d="M160.51,53.21a16.81,16.81,0,0,1,6.32,23.17,16.67,16.67,0,0,1-6.32,6.12,18.63,18.63,0,0,1-17.79,0,16.64,16.64,0,0,1-6.31-6.12,16.63,16.63,0,0,1,6.31-23.17,19,19,0,0,1,17.79,0Zm-14.39,4.9a11.27,11.27,0,0,0-4.06,15.38,11.45,11.45,0,0,0,4.09,4.09,10.79,10.79,0,0,0,5.56,1.5,10.65,10.65,0,0,0,5.5-1.5,11.48,11.48,0,0,0,4-15.43,11,11,0,0,0-4-4,10.82,10.82,0,0,0-5.5-1.47A11.15,11.15,0,0,0,146.12,58.11Z"
      />
      <path
        className="cls-3"
        d="M184.44,76.87a8,8,0,0,0,5.91,2.21,7.79,7.79,0,0,0,5.85-2.21,8.41,8.41,0,0,0,2.13-6.1V51.42h6.29V70.77a15.31,15.31,0,0,1-1.73,7.44,11.8,11.8,0,0,1-5,4.86,16,16,0,0,1-7.58,1.69,16.4,16.4,0,0,1-7.67-1.69,11.67,11.67,0,0,1-5-4.86,15.21,15.21,0,0,1-1.74-7.44V51.42h6.29V70.77A8.2,8.2,0,0,0,184.44,76.87Z"
      />
      <path
        className="cls-3"
        d="M235.89,51.42H242V84.29h-6l-16.9-22.63V84.29H213V51.42h6L235.89,74.1Z"
      />
      <path
        className="cls-3"
        d="M273.5,53.51a15.34,15.34,0,0,1,6.1,5.85,16.47,16.47,0,0,1,2.21,8.5,16.16,16.16,0,0,1-2.23,8.47,15.66,15.66,0,0,1-6.17,5.85,18.8,18.8,0,0,1-9,2.11H251V51.42h13.66A18.43,18.43,0,0,1,273.5,53.51Zm-3.26,23.85A9.79,9.79,0,0,0,274,73.51a11.47,11.47,0,0,0,1.36-5.61A11.33,11.33,0,0,0,274,62.25a9.94,9.94,0,0,0-3.87-3.9A11.15,11.15,0,0,0,264.58,57H257.3V78.75h7.51A10.68,10.68,0,0,0,270.24,77.36Z"
      />
      <path
        className="cls-3"
        d="M312.66,84.29l-2.91-7H293.69l-2.91,7h-6.53l14.42-32.87h6.52l14.23,32.87ZM295.94,71.94h11.55l-5.73-13.8Z"
      />
      <path
        className="cls-3"
        d="M320.17,51.42H347V57H336.74V84.29H330.4V57H320.17Z"
      />
      <path className="cls-3" d="M355.19,51.42h6.29V84.29h-6.29Z" />
      <path
        className="cls-3"
        d="M395.26,53.21a16.81,16.81,0,0,1,6.32,23.17,16.67,16.67,0,0,1-6.32,6.12,18.63,18.63,0,0,1-17.79,0,16.64,16.64,0,0,1-6.31-6.12,16.63,16.63,0,0,1,6.31-23.17,19,19,0,0,1,17.79,0Zm-14.39,4.9a11.27,11.27,0,0,0-4.06,15.38,11.45,11.45,0,0,0,4.09,4.09,10.79,10.79,0,0,0,5.56,1.5,10.59,10.59,0,0,0,5.49-1.5,11.47,11.47,0,0,0,4-15.43,11,11,0,0,0-4-4,10.76,10.76,0,0,0-5.49-1.47A11.15,11.15,0,0,0,380.87,58.11Z"
      />
      <path
        className="cls-3"
        d="M433.27,51.42h6.1V84.29h-6l-16.9-22.63V84.29h-6.15V51.42h6L433.27,74.1Z"
      />
      <path
        className="cls-4"
        d="M35.76,12.09a33.73,33.73,0,0,0-7.87,61.82h0l3.29-5.74-.73-.42,8.09-18.41L18.69,52.57,18.25,51,37,43.66,20.67,31.9l.83-1.45,18.41,8.09L36.69,18.69l1.61-.44,6.82,17.51L59.63,14.43a33.49,33.49,0,0,0-23.87-2.34Z"
      />
      <path
        className="cls-3"
        d="M70.57,36.69,71,38.3,52.27,45.6,68.58,57.35l-.83,1.46L49.34,50.72l3.23,19.85L51,71,43.66,52.27,31.9,68.58l-.72-.41-3.29,5.74A33.73,33.73,0,0,0,63,16.37L52,39.7Z"
      />
    </g>
  </svg>
);
